import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d10938e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = { class: "search-title" }
const _hoisted_3 = {
  key: 0,
  class: "search-title",
  style: {"border-top":"1px solid #F0F0F0","padding-top":"16px"}
}
const _hoisted_4 = { style: {"margin-bottom":"10px"} }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep, template } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'
import { apiShopName } from '@/common/const'
import { getCustomerShopPlatform, isJA } from '@/store'
import { useStore } from 'vuex'
import { syncOrderGoodsStatus, syncOrderReplenishStatus } from './data'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: ['form', 'states', 'isShopify', 'goodsForm', 'tabData', 'isTkWhiteUser'],
  emits: ['update:form'],
  setup(__props, { expose, emit: emits }) {

const props = __props


const store = useStore()
const route = useRoute()
const showGoodsSearch = computed(() => {
  return ['2', '3'].includes(props.tabData) && isJA()
})
const showUser = computed(() => location.href.includes('master-s.theckb.com') || ['107', '87'].includes(store.getters.membership.superCustomerId))

const searchDate = computed({
  get: () => [_form.value.shopOrderStartTime, _form.value.shopOrderEndTime],
  set: (newVal) => {
    [_form.value.shopOrderStartTime, _form.value.shopOrderEndTime] = newVal ?? []
  }
})

const defaultForm = {
  shopOrderId: '',
  shopOrderStartTime: '',
  shopOrderEndTime: '',
  province: '',
  country: '',
  tiktokOrderFlag: '',
  mappingStatus: ''
}

const defaultFormGoods = {
  productSku: route.query.productSku || '',

}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const getGoodForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultFormGoods)

const _form = ref(getForm(props.form))
const _goods_form = ref(getGoodForm(props.goodsForm))

watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})

const submit = () => {
  if (['0', '1'].includes(props.tabData)) {
    clearForm(_goods_form.value)
    console.log(_goods_form.value)
  } else {
    _form.value.orderName = ''
  }
  emits('update:form', cloneDeep({ ...toRaw(_form.value), ...toRaw(_goods_form.value) }))
}

const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep({ ...toRaw(_form.value), ...toRaw(_goods_form.value) }))
}

const resetGoodForm = () => {
  clearForm(_goods_form.value)
  emits('update:form', cloneDeep({ ...toRaw(_form.value), ...toRaw(_goods_form.value) }))
}

expose({
  submit
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('订单搜索')), 1),
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value,
      "label-width": "110px",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('店铺订单号'),
          prop: "shopOrderId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.shopOrderNo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.shopOrderNo) = $event)),
              onDblclick: _cache[1] || (_cache[1] = ($event: any) => {_form.value.shopOrderNo = ''; _unref(dblclick)('shopOrderNos')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"230px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        (['0', '1'].includes(__props.tabData))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('订单时间')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(searchDate),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": _unref(t)('开始时间'),
                  "end-placeholder": _unref(t)('结束时间'),
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"230px"}
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (__props.isShopify && ['0', '1'].includes(__props.tabData))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _unref(t)('订单') + `(${_unref(getCustomerShopPlatform)()})`,
              prop: "orderName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.orderName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.orderName) = $event)),
                  onDblclick: _cache[4] || (_cache[4] = ($event: any) => {_form.value.orderName = ''; _unref(dblclick)('orderNames')}),
                  placeholder: _unref(t)('双击批量搜索'),
                  style: {"width":"230px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('收件人'),
          prop: "orderName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.receiveName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.receiveName) = $event)),
              style: {"width":"230px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(showUser) && !_unref(showGoodsSearch))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('国/地区'),
                prop: "country"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _form.value.country,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.country) = $event)),
                    style: {"width":"230px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('都道府县'),
                prop: "province"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _form.value.province,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_form.value.province) = $event)),
                    style: {"width":"230px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : _createCommentVNode("", true),
        (__props.isTkWhiteUser)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "Tiktok注文",
              prop: "platformOrderType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.tiktokOrderFlag,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_form.value.tiktokOrderFlag) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('是1'),
                      value: 1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isJA)() && __props.tabData === '0')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "紐付状態（商品連携）",
              prop: "mappingStatus",
              "label-width": "150"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.mappingStatus,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_form.value.mappingStatus) = $event)),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('すべて紐付済み'),
                      value: 1
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('一部紐付済み'),
                      value: 2
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('未紐付'),
                      value: 3
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: resetForm }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_unref(showGoodsSearch))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('商品搜索')), 1))
      : _createCommentVNode("", true),
    (_unref(showGoodsSearch))
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 1,
          inline: true,
          model: _goods_form.value,
          "label-width": "110px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('商品采购状态'),
              prop: "productStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _goods_form.value.productStatus,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_goods_form.value.productStatus) = $event)),
                  style: {"width":"230px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ''
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syncOrderReplenishStatus), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.value,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('平台商品SKU'),
              prop: "productSku"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _goods_form.value.productSku,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_goods_form.value.productSku) = $event)),
                  style: {"width":"230px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('商品名称'),
              prop: "productName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _goods_form.value.productName,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_goods_form.value.productName) = $event)),
                  style: {"width":"230px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: resetGoodForm }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})